import type { Step } from "react-joyride";

export const promotionRecordCreateTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ສ້າງລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງໃໝ່. ເລືອກພະນັກງານ, ຕຳແໜ່ງ ແລະ ຕື່ມຂໍ້ມູນເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="promotion-record-create-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການບັນທຶກການເລື່ອນຕຳແໜ່ງ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="promotion-record-create-form"]',
    content:
      "ເລືອກພະນັກງານ (ຕຳແໜ່ງເກົ່າຈະເລື່ອນໃຫ້ອັດຕະໂມຕິກຖ້າມີ), ຕຳແໜ່ງໃໝ່, ລະດັບ, ເງິນເດືອນ ແລະ ເຫດຜົນ. ກົດບັນທຶກເພື່ອສ້າງ.",
    placement: "top",
  },
];
